(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category-inset"] && !Shopify.designMode) return;
  try {
    



if (!customElements.get('gn-category-panel')) {

  customElements.define('gn-category-panel', class extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.buttons = Array.from(this.querySelectorAll('button[data-target]'));

      this.panels = Array.from(this.querySelectorAll('.category-product-panel'));

      this.status = this.querySelector('.category-status');

      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onClick = (event) => {

        const button = event.target.closest('button[data-target]');

        if (button && this.buttons.includes(button)) this.selectCategory(button, true);

      };

      this.onBlockSelect = (event) => {

        const card = Array.from(this.querySelectorAll('[data-category-block]')).find(item => item.dataset.categoryBlock === event.detail?.blockId);

        if (card) this.selectCategory(card.querySelector('button[data-target]'), false);

      };

      this.addEventListener('click', this.onClick);

      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.setAttribute('data-enhanced', '');

      this.selectCategory(this.buttons[0], false);

      this.queueUpdate = () => {

        if (this.frame) return;

        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateProgress(); });

      };

      window.addEventListener('scroll', this.queueUpdate, { passive: true });

      window.addEventListener('resize', this.queueUpdate, { passive: true });

      this.motion.addEventListener('change', this.queueUpdate);

      this.resizeObserver = new ResizeObserver(this.queueUpdate);

      this.resizeObserver.observe(this.querySelector('.category-grid'));

      this.updateProgress();

    }

    selectCategory(button, announce) {

      if (!button) return;

      const panel = this.panels.find(item => item.id === button.dataset.target);

      if (!panel) return;

      this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));

      this.panels.forEach(item => { item.hidden = item !== panel; });

      if (announce && this.status) this.status.textContent = `${panel.dataset.label}: ${panel.dataset.count} products shown.`;

    }

    updateProgress() {

      if (this.dataset.animate !== 'true' || this.motion.matches || (this.dataset.editor === 'true' && this.dataset.previewInset === 'true')) {

        this.style.setProperty('--category-progress', '0');

        return;

      }

      const rect = this.getBoundingClientRect();

      // A fixed viewport-based range avoids changes as cards resize or categories switch.
      const viewportHeight = window.innerHeight;
      const scrollDistance = Number(this.dataset.scrollDistance) || 100;
      const distance = Math.max(1, viewportHeight * scrollDistance / 100);
      const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / distance));

      this.style.setProperty('--category-progress', progress.toFixed(4));

    }

    disconnectedCallback() {

      this.removeEventListener('click', this.onClick);

      this.removeEventListener('shopify:block:select', this.onBlockSelect);

      window.removeEventListener('scroll', this.queueUpdate);

      window.removeEventListener('resize', this.queueUpdate);

      this.motion?.removeEventListener('change', this.queueUpdate);

      this.resizeObserver?.disconnect();

      if (this.frame) cancelAnimationFrame(this.frame);

      this.frame = null;

      this.initialized = false;

    }

  });

}




  } catch(e) { console.error(e); }
})();
})();
